
import AppSaleLayoutEditor from "@/components/sale-layout-editor/SaleLayoutEditor.vue";
import { SaleLayoutConf } from "@/models/sale-layout";
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import { ConfirmResult } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		let warningText = () => {
			return this.$ct("cancel-confirm-layout").toString();
		};
		return {
			layout: new SaleLayoutConf(),
			ready: false,
			pendingChangesNotifier: new PendingChangesNotifier(this, "layout", {warningText}),
		};
	},
	methods: {
		async save() {
			if (this.layout.ID == 0 || this.layout.ID == undefined) {
				[this.layout] = await SaleService.postSaleLayouts([this.layout]);
			} else {
				[this.layout] = await SaleService.putSaleLayouts([this.layout]);
			}
			this.$wf.notify(this.$ct("sale-layout-save-success").toString(), "success", 3000, "check");
			await this.$nextTick();
			this.pendingChangesNotifier.changesPending = false;
		},
	},
	async mounted() {
		if (this.$route.params.id) {
			try {
				this.layout = await SaleService.getSaleLayout(parseInt(this.$route.params.id));
			} catch (error) {
				this.$router.push("/settings/sale-layouts");
			}
		} else {
			this.layout = new SaleLayoutConf();
			this.layout.Data = await SaleService.getDefaultSaleLayout();
			let contactGroupId = parseInt(this.$route.query.contactGroupId as string);
			if (!Number.isNaN(contactGroupId) && contactGroupId > 0) {
				this.layout.ContactGroupID = contactGroupId;
			}
		}
		await this.$nextTick();
		this.pendingChangesNotifier.changesPending = false;
		this.ready = true;
	},
	components: {
		AppSaleLayoutEditor
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	},
	async beforeRouteLeave(from, to, next){
		let result = await this.pendingChangesNotifier.askToSave();
		if (result == ConfirmResult.CANCEL){
			return;
		}
		if (result == ConfirmResult.YES) {
			await this.save();
		}
		next();
	}
});
